module.exports = __webpack_public_path__ + "img/notification.04e38518.png";